import { getEditor } from './../editors';
import { getRenderer } from './../renderers';
var CELL_TYPE = 'password';
export default {
  editor: getEditor(CELL_TYPE),
  renderer: getRenderer(CELL_TYPE),
  copyable: false
};


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/cellTypes/passwordType.js
// module id = 26E0
// module chunks = 0